import * as React from "react";
import { ScrollView } from "react-native";

import Video from "../components/video";
import Layout from "../components/common/Layout";

function VideosScreen() {
  return (
    <Layout.Column greedy>
      <ScrollView>
        <Video.Grid emptyText="Press 'Create Video' to add a video" />
      </ScrollView>
    </Layout.Column>
  );
}

export default VideosScreen;
